import React, { Component } from 'react';

  // router 
   
  



class  Editdata extends Component {

 
   constructor(props){
     super(props)
     this.onDelete = this.onDelete.bind(this);
     this.onEdit = this.onEdit.bind(this);
      this.editSubmit = this.editSubmit.bind(this)
     this.state = {
       isEdit:false
     }
   }
  
   onDelete(e){
    e.preventDefault();
     const {onDelete , ID} = this.props
     onDelete(ID)
     console.log("judge")
   }
  
   onEdit(){
     console.log("-------")
     this.setState({isEdit:true})
   }
 
   editSubmit(event){
    event.preventDefault();
       //console.log("edit", this.title.value)
       const editmess ={
          field :this.field.value,
        //   objectID : this.objectID.value,
          value : this.value.value,
          id : this.props.ID
       }
       this.props.editNewMessage(editmess)
       this.setState({isEdit:false})
      
    //    this.objectID.value = ""
       console.log("edit", editmess)

   }
  render() {
    
   
     const {value, field , ID} = this.props;

       
          if ( this.state.isEdit == false) {
            return (

                    <tr key={ID}>
                            <td>  {field}</td>
                            <td> {value}</td>
                            <td style={{width:"25%"}}> 
                            {/* <button class="button is-light is-rounded  are-small" onClick={this.onDelete}><i class="far fa-trash-alt" style={{color:"red"}}></i></button>|
                            <button  class="button is-primary is-rounded  are-small" onClick={this.onEdit}><i class="far fa-edit"></i></button> */}
                        </td>
                    </tr>
            //    <div>  
            //       <div > 
                           
            //               <p>  {title} </p>
            //               <p>  {  objectID} </p>
                                        
            //                 <p> {author}  </p>
                          
            //              </div>
            //           <br/>
            //    </div>
            )
          }else{
            return (
              <div> 
                 
                {/* <form onSubmit={this.editSubmit}>
                <input   onChange={this.onChange}  ref={input =>this.field = input} defaultValue={field} placeholder="Field" />
                <input onChange={this.onChange} ref={input =>this.value = input} defaultValue={value} placeholder="Value" />
                <input onChange={this.onChange}type="hidden"  defaultValue={ID} ref={input =>this.objectID   = input  } />
                <button class="button is-primary is-rounded  are-small" >save</button>
                 
            
                </form> */}
             </div>
          );
          }
          
        }

   
  


}

export default Editdata;


// WEBPACK FOOTER //
// ./src/component/company/editdata.js